
  var _styles = {
  "view-more-card": {
    "display": "flex",
    "flexDirection": "column",
    "width": "1.33333rem",
    "height": "3.73333rem",
    "borderRadius": "0.21333rem",
    "alignItems": "center",
    "justifyContent": "center",
    "marginLeft": "0.53333rem"
  },
  "view-more-card__content": {
    "display": "flex",
    "width": "1.06667rem",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between"
  },
  "view-more-card__text": {
    "fontSize": "0.32rem",
    "lineHeight": "0.4rem",
    "color": "rgb(102,102,102)",
    "fontWeight": "500"
  },
  "view-more-card__icon": {
    "display": "flex",
    "flexDirection": "column"
  }
};



  module.exports = _styles;
  